import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {ApprovalModel} from '../../../../shared/dto/approval.model';
import Swal, {default as swal} from 'sweetalert2';
import {BlacklistService} from '../../../../shared/service/blacklist.service';

@Component({
  selector: 'app-return-request',
  templateUrl: './return-request.component.html',
  styleUrls: ['./return-request.component.scss']
})
export class ReturnRequestComponent implements OnInit {
  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public applicentType: string;

  constructor(private blacklistService: BlacklistService, private router: Router) { }

  ngOnInit() {

    this.approvalModel = this.fromParent.model;
    this.applicentType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to return the request?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.blacklistService.returnRequest(this.approvalModel).subscribe(
          (success: string) => {
            swal.fire('Success', 'Applicant Details Updated', 'success');
            this.blacklistService.close();

            if(this.router.url.includes('/dashboard/blacklist-authorization/')) {
              this.router.navigate(['/dashboard/blacklist-authorization']);

            }else if(this.router.url.includes('/dashboard/blacklist-verification/')) {
              this.router.navigate(['/dashboard/blacklist-verifications/',this.applicentType]);

            }else if(this.router.url.includes('/dashboard/suspend-verification/')) {
              this.router.navigate(['/dashboard/suspend-verification']);

            }else if(this.router.url.includes('/dashboard/suspend-authorization/')) {
              this.router.navigate(['/dashboard/suspend-authorization']);

            }else if(this.router.url.includes('/dashboard/blacklist-return-data/')) {
              this.router.navigate(['/dashboard/blacklist-return-data']);

            }else if(this.router.url.includes('/dashboard/suspend-blacklist-authorization/')) {
              this.router.navigate(['/dashboard/suspend-blacklist-authorization']);
            }
            },
          (error) => {
            swal.fire('Error', 'Error When Updating the Request', 'error');
          },
        );
      } else {
      }
    });
  }
}
